import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';
import ModalComponent from '../Tenant/ModalComponent/ModalComponent';
import { BsCheckCircleFill, BsCircle } from 'react-icons/bs';
import toast from 'react-hot-toast';
import { hasPermission } from '../../utils/hasPermission';
import TenantSlugs from '../../utils/TenantSlug';

export const columnLabels = {
  division_name: "Division Name",
  financial_year: "Financial Year",
  total_qty: "Total Qty",
  total_points: "Total Points",
  total_value: "Total Value",
  id: "ID",
  scheme_name: "Scheme Name",
  user_name: "User Name",
  user_mobile: "User Mobile",
  city: "City",
  district: "District",
  state: "State",
  firm_name: "Firm Name",
  batch_running_code: "Batch Running Code",
  mrp: "MRP",
  ref_no: "Reference No",
  user_type_id: "User Type ID",
  app_user_id: "App User ID",
  l1_manager_id: "L1 Manager ID",
  l1_manager_name: "L1 Manager Name",
  l1_manager: "L1 Manager",
  l1_manager_email: "L1 Manager Email",
  l1_manager_mobile: "L1 Manager Mobile",
  points: "Product Points",
  amount: "Amount",
  balance: "Balance Before Redemption",
  remarks: "Remarks",
  status: "Entry Status",
  user_status: "User Status",
  approval_status: "Approval Status",
  is_wallet: "Is Wallet",
  created_at: "Created At",
  tds_deducted_at: "TDS Deducted At",
  value: "Value",
  user_id: "User ID",
  firm_name: "Firm Name",
  mobile: "Mobile",
  profile_pic: "Profile Picture",
  image_url: "Shelf Image URL",
  reject_reason: "Rejection Reason",
  user_type_name: "User Type",
  is_address_verified: "Is Address Verified",
  point_earned: "Point Earned",
  point_balance: "Point Balance",
  point_redeemed: "Total Point Redeemed (As of Current Date)",
  point_reserved: "Point Reserved",
  point_pending: "Point Pending",
  point_expired: "Point Expired",
  cash_redeemed: "Cash Redeemed",
  cashback_balance: "Cashback Balance",
  statusUpdateDetails: "Status Update Details",
  user_type: "User Type",
  approved_by_id: "Approved By ID",
  redemption_type_id: "Redemption Type ID",
  redemption_type: "Redemption Type",
  platform_id: "Platform ID",
  platform: "Platform",
  tds_deducted: "TDS Deducted",
  name: "Name",
  email: "Email",
  gift: "Gift",
  address: "Address",
  delivery_details: "Delivery Details",
  type: "Type",
  purchase_amount: "Value / Purchase Amount",
  rank: "Rank",
  product_code: "Product Code",
  start_date: "Start Date",
  end_date: "End Date",
  created_by_id: "Created by ID",
  created_by_name: "Created By",
  updated_by_id: "Updated by ID",
  updated_by_name: "Updated By",
  created_at: "Redemption Recieved Date",
  updated_at: "Last Updated Date",
  bene_account_number: "Beneficiary Account Number / VPA",
  bene_ifsc: "Beneficiary IFSC Code",
  bene_phone: "Phone (Bene)",
  app_user_name: "Name",
  app_user_mobile: "Mobile",
  app_user_email: "Email",
  user_value: "User Value",
  trigger_value: "Trigger Value",
  offer: "Offer Type",
  trigger_status: "Trigger Status",
  qr_scan_hit_lat: "Scan Lat",
  qr_scan_hit_log: "Scan Log",
  qr_scan_hit_state: "Scan State",
  qr_scan_hit_district: "Scan District",
  qr_scan_hit_city: "Scan City",
  qr_scan_hit_pincode: "Scan Pincode",
  zone: "Zone",
  zone_name: "Zone Name",
  salon_zone: "Salon Zone",
  salon_name: "Salon Name",
  salon_id: "Salon ID",
  salon_address: "Salon Address",
  salon_pincode: "Salon Pincode",
  salon_state: "Salon State",
};

const CustomExport = ({ fetchData, data, defaultColumnExport, filename = "exported-data.csv", filterStatus = [], formatColumns = [], translateFeat = false, skipColumnLabels = false }) => {
  const resolveLabel = (col) => skipColumnLabels ? col : (columnLabels[col] || col);

  const [isDisabled, setisDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false)

  const [showColumnModal, setShowColumnModal] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState(defaultColumnExport);

  const fetchDataFunc = (translate = false) => {
    setIsLoading(true);
    fetchData(translate);
  }

  const is_aqualite =
    JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
    TenantSlugs.aqualite;


  const downloadCSV = () => {
    toast.dismiss();
    if (selectedColumns.length == 0) {
      toast.error("please select some columns.", { id: "selectSomeColumns" })
      return;
    }

    const selectedData = data.map(row => {
      const selectedRow = {};
      // selectedColumns.forEach(column => {
      //   if (column === 'status') {
      //     selectedRow[column] = row[column] === '1' ? 'Active' : row[column] === '2' ? 'Inactive' : "Deleted";
      //   } else if(column === 'points_active' ) {
      //     selectedRow[column] = row[column] === '1' ? 'Active' : 'Inactive' 
      //   }else {
      //     selectedRow[column] = row[column];
      //   }
      // });

      if (filterStatus?.includes(row?.status)) {
        return null;
      }

      if (
        filename == "extra_point_history" &&
        [null, undefined, "null", "0"].includes(row?.user_status)
        && JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.borosil
      ) {
        return null;
      }

      selectedColumns.forEach((column) => {
        let cellData = row[column];
        // Check if the cell data is an object
        if (typeof cellData === 'object') {
          // Convert object to string representation
          cellData = JSON.stringify(cellData);
        }

        //Timestampz to local string
        const isIsoTimestamp = typeof cellData === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(cellData);
        if (isIsoTimestamp) {
          try {
            const date = new Date(cellData);
            // Format to "dd/MM/yyyy, HH:mm:ss" in IST (Asia/Kolkata)
            const formattedDate = date.toLocaleString('en-GB', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false,
              timeZone: is_aqualite ? "UTC" : 'Asia/Kolkata'
            });

            selectedRow[column] = formattedDate;
            return;
          } catch (e) {
            selectedRow[column] = cellData;
            return;
          }
        }

        if (column === 'gift' && formatColumns?.includes("gift")) {
          const raw_data = JSON.parse(cellData || {});
          const gift = raw_data?.gift
            ? Array.isArray(raw_data?.gift)
              ? raw_data?.gift[0]
              : raw_data?.gift
            : raw_data
              ? Array.isArray(raw_data)
                ? raw_data[0]
                : raw_data
              : {};

          // selectedRow[column] = [
          //     `Name: ${gift.name || "N/A"}`,
          //     `Brand: ${gift.brand || "N/A"}`,
          //     `Value: ${gift.value || "N/A"}`,
          //     `Category: ${gift.category || "N/A"}`,
          // ].join("\n");

          // create multiple flattened columns
          selectedRow["Gift Name"] = gift.name || "N/A";
          selectedRow["Gift Brand"] = gift.brand || "N/A";
          selectedRow["Gift Value"] = gift.value || "N/A";
          selectedRow["Gift Category"] = gift.category || "N/A";
          return; // skip generic assignment
        } else if (column === 'address' && formatColumns?.includes("address")) {
          cellData = JSON.parse(cellData || {});

          selectedRow[resolveLabel(column)] = `${cellData?.address}, ${cellData?.city}, ${cellData?.district}, ${cellData?.state}, ${cellData?.country} - ${cellData?.pincode}`;
          selectedRow['City'] = cellData?.city;
          selectedRow['District'] = cellData?.district;
          selectedRow['State'] = cellData?.state;
          selectedRow['Pincode'] = cellData?.pincode;
        } else if (column === 'delivery_details' && formatColumns?.includes("delivery_details")) {
          cellData = JSON.parse(cellData || {});

          const fileLinks = (cellData?.image || [])
            ?.map((item) => `'${item?.fileLink}'`)
            .join(", ");

          // selectedRow[column] = [
          //     `Tracking ID: ${cellData.tracking_id || "N/A"}`,
          //     `Delivery Partner: ${cellData.delivery_partner || "N/A"}`,
          //     `Files: ${fileLinks?.length > 0 ? fileLinks : "N/A"}`,
          // ].join("\n"); 

          selectedRow["Tracking ID"] = cellData.tracking_id || "N/A";
          selectedRow["Delivery Partner"] = cellData.delivery_partner || "N/A";
          selectedRow["Delivery Files"] = fileLinks || "N/A";
          return;
        } else if (column === 'statusUpdateDetails' && formatColumns?.includes("statusUpdateDetails")) {
          let approvedData = null;
          let orderPlacedData = null;
          let deliveredData = null;

          JSON.parse(cellData || {})?.map((item) => {
            if (item?.status_name === "approved") {
              approvedData = item;
            }

            if (item?.status_name === "order placed") {
              orderPlacedData = item;
            }

            if (item?.status_name === "delivered") {
              deliveredData = item;
            }
          });

          const lastStatus = JSON.parse(cellData || {})?.[
            JSON.parse(cellData || {}).length - 1
          ];

          selectedRow["Current Status"] = lastStatus?.status_name;
          selectedRow["Current Status On"] = lastStatus?.created_at
            ? new Date(lastStatus?.created_at).toLocaleString()
            : null;

          selectedRow["Approved On"] = approvedData?.created_at
            ? new Date(approvedData?.created_at).toLocaleString()
            : null;
          selectedRow["Approved By"] = approvedData?.created_name
            ? approvedData?.created_name
            : null;

          selectedRow["Order Placed On"] = orderPlacedData?.created_at
            ? new Date(orderPlacedData?.created_at).toLocaleString()
            : null;
          selectedRow["Order Placed By"] = orderPlacedData?.created_name
            ? orderPlacedData?.created_name
            : null;

          selectedRow["Delivered On"] = deliveredData?.created_at
            ? new Date(deliveredData?.created_at).toLocaleString()
            : "N/A";

          return;
        } else if (column === 'status' && filename.startsWith("schemeRedemptions")) {
          selectedRow["Approval Status"] =
            cellData === '3' || cellData === 3
              ? 'Pending'
              : cellData === '1' || cellData === 1
                ? 'Approved'
                : cellData === '2' || cellData === 2
                  ? 'Rejected'
                  : cellData;
          return;
        } else if (column === 'status' && filename == "cash_transactions") {
          console.log("cash_transactions at export");
          selectedRow[resolveLabel(column)] =
            cellData === '1'
              ? 'Success'
              : cellData === '2'
                ? 'Pending'
                : cellData === '0' ? 'Error' : cellData;
        }
        else if (column === 'approval_status' && filename == "coupon_request_list") {
          console.log("coupon_request_list at export");
          selectedRow[resolveLabel(column)] =
            cellData === '1'
              ? 'Pending'
              : cellData === '2'
                ? 'Accepted'
                : cellData === '3' ? 'Rejected' : cellData;
        }
        else if (column === 'approval_status' && filename == "cash_transfer_request_list") {
          console.log("cash_transfer_request_list at export");
          selectedRow[resolveLabel(column)] =
            cellData === '3'
              ? 'Pending'
              : cellData === '1'
                ? 'Approved'
                : cellData === '2' ? 'Rejected' : cellData;
        }
        else if (column === 'status' && filename == "cash_transfer_request_list") {
          selectedRow[resolveLabel(column)] =
            cellData === '1'
              ? 'Sucess'
              : cellData === '2'
                ? 'Pending'
                : cellData === '0' ? 'Error' : cellData;
        } else if (column === 'status' && filename === "pending_qr_report") {
          selectedRow[resolveLabel(column)] =
            cellData === '1'
              ? 'Pending'
              : cellData === '3'
                ? 'Rejected'
                : cellData === '2' ? 'Approved' : cellData;
        }
        else if (column === 'status' || column === 'user_status') {
          selectedRow[resolveLabel(column)] =
            cellData === '1'
              ? 'Active'
              : cellData === '2'
                ? 'Inactive'
                : cellData === '0' ? 'Deleted' : cellData;
        } else if (column === 'approval_status') {
          selectedRow[resolveLabel(column)] =
            cellData === '1'
              ? 'Accepted'
              : cellData === '2'
                ? 'Rejected'
                : cellData === '3' ? 'Pending' : cellData;
        } else if (column === 'trigger_status') {
          selectedRow[resolveLabel(column)] =
            cellData === '2' || cellData === 2
              ? 'Claimed'
              : 'Pending';
        }
        else if (['bene_account_number', 'bene_ifsc'].includes(column) && cellData != null && cellData !== '') {
          // Prefix with tab so Excel treats the value as text and preserves leading zeros
          selectedRow[resolveLabel(column)] = `\t${cellData}`;
        }
        else {
          selectedRow[resolveLabel(column)] = cellData;
        }
      });

      return selectedRow;
    })?.filter(Boolean);

    const csv = Papa.unparse(selectedData);
    const name = filename + "-" + new Date().toISOString().replace(/:/g, '-').split('T')[0];
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setShowColumnModal(false);
  };

  // console.log("data", data);
  useEffect(() => {
    toast.dismiss();
    // console.log("data", data, data?.length);
    if (data && data.length > 0) {
      setIsLoading(false);
      setisDisabled(false);
      setShowColumnModal(true);
    }
    else if (data && data.length == 0) {
      toast("No data available", { id: "noData" });
      setIsLoading(false);
    }
  }, [data])

  const handleColumnChange = (e) => {
    const { name, checked } = e.target;
    if (checked) {
      setSelectedColumns([...selectedColumns, name]);
    } else {
      setSelectedColumns(selectedColumns.filter(column => column !== name));
    }
  };

  const downloadCsvFunc = () => {
    if (!showColumnModal) {
      setShowColumnModal(true);
    }
  }

  const handleSelectAll = () => {
    if (data && data.length > 0) {
      const allColumns = Object.keys(data[0]);
      setSelectedColumns(allColumns);
    }
  };

  const handleClearAll = () => {
    setSelectedColumns([]);
  };

  const exportCSVPermission = true;

  return (
    exportCSVPermission &&
    <div className='flex space-x-3 justify-start items-center '>
      {translateFeat && (
        <button className='btn btn-outline-secondary' onClick={() => {
          fetchDataFunc(true)
        }}>Fetch CSV (English)</button>
      )}
      <button className='btn btn-outline-secondary' onClick={() => {

        fetchDataFunc(false)
      }}>Fetch CSV </button>
      <button className='btn btn-outline-primary' onClick={downloadCsvFunc} disabled={isDisabled}>
        {isLoading ? (
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        ) : (
          "Download CSV"
        )}
      </button>

      {showColumnModal && (
        <ModalComponent
          size={"5xl"}
          data={"nadnandand"}
          show={showColumnModal}
          setShow={setShowColumnModal}
        >
          <div className="w-full p-4">
            <div className="w-full m-auto  justify-center ">
              <div className="column-selection-popup">
                <h3 className='font-semibold text-lg pb-2 text-center'>Select Columns to export</h3>
                <div className="flex justify-start my-3 space-x-2">
                  <button
                    className="btn btn-outline-primary"
                    onClick={handleSelectAll}

                  >
                    Select All
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleClearAll}

                  >
                    Clear All
                  </button>
                </div>
                <div className='flex justify-start items-center flex-wrap space-x-1'>
                  {data && data.length > 0 ? Object.keys(data[0]).map(column => (
                    <div key={column} className=' w-36 m-auto flex items-center'>
                      <label className={`flex justify-start items-center p-1 rounded-md hover:bg-gray-100 w-full ${selectedColumns.includes(column) ? " bg-gray-100" : "  "} `} >
                        <input
                          type="checkbox"
                          // className='hidden'
                          name={column}
                          checked={selectedColumns.includes(column)}
                          onChange={handleColumnChange}
                        />
                        {/* {selectedColumns.includes(column) ? (
                          <BsCheckCircleFill className="w-3.5 mr-1" />
                        ) : (
                          <BsCircle className="w-3.5 mr-1" />
                        )} */}
                        <span className='ml-0.5'>
                          {resolveLabel(column)}
                        </span>
                      </label>
                    </div>
                  ))
                    : <h3 className='text-xl font-semibold text-center'>No data to export</h3>
                  }
                </div>
              </div>
            </div>
            <div className="flex justify-center mt-3 space-x-2">
              <button
                className="text-white bg-blue-600 hover:bg-blue-800 focus-ring-4 focus-outline-none focus-ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center"
                onClick={() => {
                  downloadCSV();
                }}
              >
                Download
              </button>

              <button
                className="text-white bg-red-600 hover:bg-red-800 focus-ring-4 focus-outline-none focus-ring-red-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center"
                onClick={() => {
                  setShowColumnModal(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </ModalComponent>
      )}
    </div>
  );
};

export default CustomExport;
